import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useToast from '../contexts/useToast';

const AuthCallback = () => {
  const { showToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('successful') === 'false';
    const returnTo = params.get('returnTo') || '/';
    const wasPlaying = params.get('wasPlaying') === 'true';

    if (error) {
      showToast('Login failed. Please try again or contact support.', 'error');
    }

    // Build final URL, adding isPlaying if user was playing when prompted
    const finalUrl = wasPlaying ? `${returnTo}?isPlaying=true` : returnTo;
    navigate(finalUrl, { replace: true });
  }, [showToast, navigate]);

  return null;
};

export default AuthCallback;
